import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

/**
 * Hook global de permissões efetivas do usuário logado.
 * - Se feature flag OFF ou role=master, .can() retorna true sempre.
 * - Cacheado por sessão; refresh() força reload.
 */
let cache = { data: null, promise: null };

export function invalidatePermissionsCache() {
  cache = { data: null, promise: null };
}

export function usePermissions() {
  const [data, setData] = useState(cache.data);
  const [loading, setLoading] = useState(!cache.data);

  const load = useCallback(async (force = false) => {
    if (!force && cache.data) { setData(cache.data); setLoading(false); return; }
    if (!cache.promise) {
      cache.promise = api.get("/permissions/me")
        .then((r) => { cache.data = r.data; return r.data; })
        .catch(() => {
          const fallback = { granular_enabled: false, master_bypass: false, permissions: {} };
          cache.data = fallback;
          return fallback;
        })
        .finally(() => { cache.promise = null; });
    }
    setLoading(true);
    const d = await cache.promise;
    setData(d);
    setLoading(false);
  }, []);

  useEffect(() => { load(false); }, [load]);

  const can = useCallback((moduleKey, action = "view") => {
    if (!data) return true; // enquanto carrega, permite (evita flicker)
    if (data.master_bypass) return true;
    if (!data.granular_enabled) return true;
    return !!data.permissions?.[moduleKey]?.[action];
  }, [data]);

  return { data, loading, can, refresh: () => load(true) };
}
